export const MAGIC_ROW = 'magic_row';

export function getMagicRowLabel() {
  return 'For you';
}
